module.exports = __webpack_public_path__ + "/images/banner.png";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp-files/images/banner.png
// module id = 207
// module chunks = 0